import { ParentGuardianResponseDto } from "../shared/dtos/parentGuardian/ParentGuardianResponseDto";
import { ParentGuardianSummaryDto } from "../shared/dtos/parentGuardian/ParentGuardianSummaryDto";

export class ParentGuardianMapper {
  public static mapParentToSummary(
    detailedParent: ParentGuardianResponseDto,
  ): ParentGuardianSummaryDto {
    return {
      id: detailedParent.id,
      firstName: detailedParent.firstName,
      lastName: detailedParent.lastName,
      email: detailedParent.email,
      primaryPhoneNumber: detailedParent.primaryPhoneNumber,
      occupation: detailedParent.occupation,
    };
  }
}
